export const GET_ACCOUNTS = `
  query getAccounts {
    listAccounts {
      id
      accountId
      accountName
      createdDate
      email
      status
      masterRefId
    }
  }
`
